<template>
    <div class="text-center full-height">
        <div class="form-signin">
            <img src="@/assets/logo-frontex.png" class="mb-4" v-on:click="fillLogin">

            <transition
                    v-on:enter="transitions.slideDown"
                    v-on:leave="transitions.slideUp"
                    v-bind:css="false"
            >
                <div class="sign-in" v-if="!signingIn">
                    <h1 class="h3 mb-3 font-weight-normal">Please sign in</h1>

                    <label for="inputEmail" class="sr-only">Email address</label>
                    <input type="email" id="inputEmail" class="form-control" placeholder="Email address" autocomplete="off" v-model="username">

                    <label for="inputPassword" class="sr-only">Password</label>
                    <input type="password" id="inputPassword" class="form-control mb-0" placeholder="Password" autocomplete="off" v-model="password" v-on:keyup.enter="signIn">
                </div>
            </transition>

            <button
                    class="btn btn-lg btn-primary btn-block mt-3 btn-sign-in"
                    :class="(canSignIn ? '' : ' disabled') + (signingIn ? ' signing-in disabled' : '')"
                    type="submit"
                    v-on:click="signIn"
                    v-text="signingIn ? 'Signing in..' : 'Sign in'"
            />
        </div>
    </div>
</template>

<script>
    import transitions from '@/utils/VelocityTransitions.js';
    import * as types from '@/store/mutation-types'
    import * as MutationTypes from '@/store/mutation-types'

    export default {
        name: 'login-view',
        mounted() {
            let cookieToken = this.$cookies.get('token');

            if (cookieToken) {
                this.signingIn = true;

                this.$apiClient.setBearerToken(cookieToken);

                this.$apiClient.getUserData().then((data) => {
                    this.onLoggedIn(cookieToken, data.userData);
                }).catch((error) => {
                    this.onLoginError(null);
                });
            }
        },
        data() {
            return {
                transitions: transitions,

                username: '',
                password: '',
                signingIn: false
            }
        },
        methods: {
            onLoginError(error) {
                this.loginError = error || null;

                this.$apiClient.setBearerToken(null);

                this.signingIn = false;
            },
            onLoggedIn(token, userData) {
                this.$cookies.set('token', token);

                this.$apiClient.setBearerToken(token);

                this.$store.commit(MutationTypes.SET_USER_TOKEN, token);
                this.$store.commit(MutationTypes.SET_CURRENT_USER, userData);

                let redirectUrl = '/admin';

                if (this.$router.currentRoute.query.hasOwnProperty('redirect')) {
                    redirectUrl = this.$router.currentRoute.query.redirect;
                }

                console.log('logged in !!');
                this.$router.push(redirectUrl);

                this.signingIn = false;
            },
            fillLogin() {
                this.username = 'aj@seriousgames.net';
                this.password = 'aj';
            },
            signIn() {
                if (this.signingIn || !this.canSignIn) {
                    return;
                }

                this.signingIn = true;

                this.$apiClient.login(this.username, this.password).then((data) => {
                    this.onLoggedIn(data.token, data.userData);
                }).catch((error) => {
                    this.onLoginError(error);
                });

                return;
            }
        },
        computed: {
            canSignIn() {
                return this.username && this.password;
            }
        }
    }
</script>

<style scoped lang="scss">
    .form-signin {
        width: 100%;
        max-width: 330px;
        padding: 15px;

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .checkbox {
            font-weight: 400;
        }

        .form-control {
            position: relative;
            box-sizing: border-box;
            height: auto;
            padding: 10px;
            font-size: 16px;

            &:focus {
                z-index: 2;
            }
        }

        .btn {
            &.disabled {
                opacity: .3;
            }
        }

        input[type="email"] {
            margin-bottom: -1px;
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
        }

        input[type="password"] {
            margin-bottom: 10px;
            border-top-left-radius: 0;
            border-top-right-radius: 0;
        }
    }

    .btn-sign-in {
        &.signing-in {
            margin-top: 0 !important;
        }
    }
</style>
